// Browser/ES5 targets
module.exports = require('./lib-es5')
